<template>
  <div class="dashboard" >
      <v-dialog
        v-model="loading"
        persistent
        width="600"
        >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Proccessing <span v-if="customLog"> {{customLog}}</span>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout wrap row justify-start class="ma-5">
        <v-flex xs8 px-2 mb-2 CallCenterSettings>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Call Center Settings
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t3 = !t3">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t3">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs12 pa-1 Agents>
                  <v-flex xs4 px-1 style="font-size:11px;font-weight:700;">
                    Agents
                  </v-flex>
                  <v-text-field
                    label="Active Agents"
                    v-model="callcenter.agents"
                    solo
                    @keydown="isNumber($event)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pa-1 Calls>
                  <v-flex xs4 px-1 style="font-size:11px;font-weight:700;">
                    Calls
                  </v-flex>
                  <v-text-field
                    label="Active Calls"
                    v-model="callcenter.calls"
                    solo
                    @keydown="isNumber($event)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pa-1 Cycle Size>
                  <v-flex xs4 px-1 style="font-size:11px;font-weight:700;">
                    Cycle Size
                  </v-flex>
                  <v-text-field
                    label="Cycle Size"
                    v-model="callcenter.cycle_size"
                    solo
                    @keydown="isNumber($event)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 px-1 Exclude>
                  <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                    Exclude From Active Automation
                  </v-flex>
                  <v-autocomplete
                    label="Job"
                    solo
                    multi-line
                    multiple
                    v-model="callcenter.automation.short_automation.exclude"
                    hide-details
                    item-text="job_name"
                    item-value="job_id"
                    :items="jobs"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 pa-1 SELECTSTATUSES>
                  <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                    Success Statuses
                  </v-flex>
                  <v-autocomplete
                    label="Call Status"
                    solo
                    v-model="callcenter.automation.short_automation.good"
                    hide-details
                    multiple
                    item-value="enumeration"
                    item-text="enumeration"
                    :items="sys"
                  >
                    <template
                        slot="selection"
                        slot-scope="{ item }"
                    >
                      <v-chip small style="font-size:9px;" label>{{item.enumeration}}</v-chip>
                    </template>

                    <template
                        slot="item"
                        slot-scope="{ parent, item }"
                    >
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template slot="activator">
                            <v-icon on="on" color="error" v-if="item.description">info</v-icon>
                          </template>
                          <div>{{item.description}}</div>
                        </v-tooltip>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.enumeration"></v-list-tile-title>
                        <v-list-tile-sub-title v-if="item.cause" style="font-size:9px;"> cause: {{item.cause}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.description" style="font-size:9px;">{{item.description}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 pa-1 FAILSTATUSLIMIT>
                  <v-layout row wrap>
                    <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                      Global Fail Retry
                    </v-flex>
                    <v-flex xs12 v-for="(fail, f) in callcenter.fail" :key="'fail' + f">
                      <v-layout row wrap>
                        <v-flex xs6 pa-1 SELECTSTATUSES>
                          <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                            Fail Statuses
                          </v-flex>
                          <v-autocomplete
                            label="Call Status"
                            solo
                            v-model="fail.status"
                            hide-details
                            item-value="enumeration"
                            item-text="enumeration"
                            :items="sys"
                          >
                            <template
                                slot="selection"
                                slot-scope="{ item }"
                            >
                              <v-chip small style="font-size:9px;" label>{{item.enumeration}}</v-chip>
                            </template>
                            <template
                                slot="item"
                                slot-scope="{ parent, item }"
                            >
                              <v-list-tile-action>
                                <v-tooltip top>
                                  <template slot="activator">
                                    <v-icon on="on" color="error" v-if="item.description">info</v-icon>
                                  </template>
                                  <div>{{item.description}}</div>
                                </v-tooltip>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="item.enumeration"></v-list-tile-title>
                                <v-list-tile-sub-title v-if="item.cause" style="font-size:9px;"> cause: {{item.cause}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-if="item.description" style="font-size:9px;">{{item.description}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs6 pa-1>
                          <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                            # of Resets
                          </v-flex>
                          <v-text-field
                            label="# of Resets"
                            v-model="fail.retries"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-btn color="primary" @click="()=>{
                          if(!callcenter.fail) callcenter.fail = []
                          callcenter.fail.push({})
                        }">add status</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pa-1 STATUSCRMACTION>
                  <v-layout row wrap>
                    <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                     Actions On CTM
                    </v-flex>
                    <v-flex xs12 v-for="(action, f) in callcenter.actions" :key="'fail' + f">
                      <v-layout row wrap>
                        <v-flex xs6 pa-1 SELECTSTATUSES>
                          <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                            Status
                          </v-flex>
                          <v-flex xs12 px-1>
                            <v-autocomplete
                              label="Order Status"
                              solo
                              v-model="action.status"
                              hide-details
                              item-text="name"
                              item-value="name"
                              :items="statuses"
                            ></v-autocomplete>
                          </v-flex>
                        </v-flex>
                        <v-flex xs6 pa-1>
                          <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                            Action
                          </v-flex>
                          <v-autocomplete
                            label="Action"
                            solo
                            v-model="action.do"
                            hide-details
                            item-text="name"
                            item-value="name"
                            :items="['REMOVE', 'RESET', 'NOTHING']"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-btn color="primary" @click="()=>{
                          if(!callcenter.actions) callcenter.actions = []
                          callcenter.actions.push({})
                        }">add status</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 INBOUND SETTINGS>
                  <v-layout row wrap>
                    <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                      INBOUND SETTINGS
                    </v-flex>
                    <v-flex xs12 v-for="(inbound, nn) in callcenter.inbound_campaigns" :key="'inbound-' + nn">
                      <v-layout row wrap>
                        <v-flex xs6 px-1 style="font-size:11px;font-weight:700;">
                          Campaign #
                        </v-flex>
                        <v-flex xs6 px-1 style="font-size:11px;font-weight:700;">
                          Country
                        </v-flex>
                        <v-flex xs6 px-1>
                          <v-text-field
                            label="Campaign"
                            @keydown="isNumber($event)"
                            solo
                            v-model="inbound.campaign"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 px-1>
                          <v-autocomplete
                            label="Country"
                            solo
                            multi-line
                            v-model="inbound.country"
                            hide-details
                            item-text="name"
                            item-value="alph2Code"
                            :items="countries"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 px-1>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-btn color="primary" @click="()=>{
                          if(!callcenter.inbound_campaigns) callcenter.inbound_campaigns = []
                          callcenter.inbound_campaigns.push({})
                        }">add inbound campaign</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 MISSED CAMPAING>
                  <v-layout row wrap>
                    <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                      MISSED CALL JOB
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        label="Job"
                        solo
                        multi-line
                        v-model="callcenter.inbound_missed_call"
                        hide-details
                        item-text="job_name"
                        item-value="job_id"
                        :items="jobs"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 px-1 style="font-size:11px;font-weight:700;">
                      GET MISSED CALLS AFTER
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                        ref="misscalltimemenue"
                        v-model="misscalltimemenue"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template slot="activator">
                          <v-text-field
                            v-model="callcenter.inbound_missed_call_time"
                            label="Time"
                            solo
                            prepend-icon="access_time"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="misscalltimemenue"
                          v-model="callcenter.inbound_missed_call_time"
                          full-width
                          format="24hr"
                          @click:minute="$refs.misscalltimemenue.save(callcenter.inbound_missed_call_time)"
                        ></v-time-picker>
                        <v-card>
                          <v-card-actions>
                            <v-btn color="success" flat @click="misscalltimemenue = false">confirm</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-switch label="Backend Active 1 Minute Quick Automation" v-model="callcenter.automation.quick.active"></v-switch>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-switch label="Backend Active 5 Minutes Automation" v-model="callcenter.automation.short_automation.active"></v-switch>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-switch label="Backend Control Automation" v-model="callcenter.automation.minute.active"></v-switch>
                </v-flex>
                <v-flex xs12 pa-1>
                  <v-switch label="Backend 24h/Day Automation" v-model="callcenter.automation.day.active"></v-switch>
                </v-flex>
                <v-flex xs12 pa-1>
                  {{ result }}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t3">
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="loading" @click="saveCallCenterSettings()">update settings</v-btn>
              <v-btn color="error" @click=AutomationMinuteShortCycle>All Active Jobs Numbers Reset</v-btn>
              <v-btn color="error" @click=controlAutomation>Minute Automation</v-btn>
            </v-card-actions>
            <v-card-actions v-if="t3">
              <v-spacer></v-spacer>
              TESTING
              <v-btn color="error" @click=jobsTesting>add random to</v-btn>
              <v-btn color="error" @click=AutomationDayCycle>day cycle</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs4 px-2 mb-2 JOB-Manager>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							JOBS Manager
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t2 = !t2">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t2">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs12 px-1>
                  <v-autocomplete
                    label="Job"
                    solo
                    v-model="selectedJob"
                    hide-details
                    item-text="job_name"
                    return-object
                    @change="checkJobStatus()"
                    :items="jobs"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 pa-2 v-if="Object.keys(jobStatus).length">
                  <v-layout row wrap class="text-xs-left" align-center>
                    <v-flex xs12 px-1 v-for="(key, k) in Object.keys(jobStatus)" :key="'job-stat-key-'+ k">
                      <span style="font-size:11px;font-weight:700;">{{ key.split('_').join(' ').toUpperCase() }}</span>  :  {{ jobStatus[key] }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t2">
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="loading" :disabled="!selectedJob" @click="getJobNumbers()">get job numbers</v-btn>
            </v-card-actions>
            <v-card-actions v-if="t2">
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="loading" :disabled="!selectedJob" @click="startStopJob(true)" icon>
                <v-icon color="white">play_arrow</v-icon>
              </v-btn>
              <v-btn color="primary" :loading="loading" :disabled="!selectedJob" @click="startStopJob()" icon>
                <v-icon color="white">pause</v-icon>
              </v-btn>
              <v-btn color="primary" :loading="loading" :disabled="!selectedJob" @click="saveSetting()">reset job</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 px-2 mb-2 JOBS-SETUP>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							JOBS Setup
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t1 = !t1">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t1">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs4 px-1>
                  <span style="font-size:11px;font-weight:700;">Company Code</span>
                  <v-autocomplete
                    name="Company Code"
                    label="Company Code"
                    solo
                    @change="checkIfSettingExists()"
                    :items="company_codes"
                    v-model="companycode"
                    item-text="company_code"
                    item-value="company_code"
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 px-1>
                  <span style="font-size:11px;font-weight:700;">Priority</span>
                  <v-text-field
                    label="Priority"
                    v-model="jobsGroup.priority"
                    solo
                    @keydown="isNumber($event)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 pa-1>
                  <span style="font-size:11px;font-weight:700;">Concurrent</span>
                  <v-text-field
                    label="Concurrent"
                    v-model="jobsGroup.con"
                    solo
                    @keydown="isNumber($event)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="text-xs-left" align-center>
                    <v-flex xs12 pa-1>
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          Status
                        </v-flex>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          Job
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Priority
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Concurrent
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Retries #
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Hours #
                        </v-flex>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          Success
                        </v-flex>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1 v-for="(job, j) in jobsGroup.jobs" :key="j+ '-jobsetup'">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2 px-1>
                          <v-autocomplete
                            label="Order Status"
                            solo
                            v-model="job.status"
                            hide-details
                            item-text="name"
                            item-value="name"
                            :items="statuses"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs2 px-1>
                          <v-autocomplete
                            label="Call Center Job"
                            solo
                            v-model="job.job"
                            hide-details
                            item-text="job_name"
                            return-object
                            :items="jobs"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Priority"
                            v-model="job.priority"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Concurrent"
                            v-model="job.con"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Retries #"
                            v-model="job.retries"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Hours #"
                            v-model="job.hours"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 pa-1 SELECTSTATUSES>
                          <v-autocomplete
                            label="Call Status"
                            solo
                            v-model="job.call_statuses"
                            hide-details
                            multiple
                            item-value="enumeration"
                            item-text="enumeration"
                            :items="sys"
                          >
                            <template
                                slot="selection"
                                slot-scope="{ item }"
                            >
                              <v-chip small style="font-size:9px;" label>{{item.enumeration}}</v-chip>
                            </template>

                            <template
                                slot="item"
                                slot-scope="{ parent, item }"
                            >
                              <v-list-tile-action>
                                <v-tooltip top>
                                  <template slot="activator">
                                    <v-icon on="on" color="error" v-if="item.description">info</v-icon>
                                  </template>
                                  <div>{{item.description}}</div>
                                </v-tooltip>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="item.enumeration"></v-list-tile-title>
                                <v-list-tile-sub-title v-if="item.cause" style="font-size:9px;"> cause: {{item.cause}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-if="item.description" style="font-size:9px;">{{item.description}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-checkbox label="New Job" v-model="job.new" :value="true"></v-checkbox>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-checkbox label="Lock Job" v-model="job.lock" :value="true"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-btn color="primary" @click="jobsGroup.jobs.push({})">add job</v-btn>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          Status
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          To
                        </v-flex>
                        <v-flex xs2 px-1 style="font-size:11px;font-weight:700;">
                          Status
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Hours
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:700;">
                          Calls
                        </v-flex>
                        <v-flex xs3 px-1 style="font-size:11px;font-weight:700;">
                          Success
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1 v-for="(rule, r) in jobsGroup.rules" :key="r+ '-rulesetup'">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2 px-1>
                          <v-autocomplete
                            label="Order Status"
                            solo
                            v-model="rule.fstatus"
                            hide-details
                            item-text="name"
                            item-value="name"
                            :items="statuses"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs1 px-1 class="text-xs-center">
                          ---TO-->
                        </v-flex>
                        <v-flex xs2 px-1>
                          <v-autocomplete
                            label="Order Status"
                            solo
                            v-model="rule.tstatus"
                            hide-details
                            item-text="name"
                            item-value="name"
                            :items="statuses"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Number of hours"
                            v-model="rule.hours"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 pa-1>
                          <v-text-field
                            label="Number of calls"
                            v-model="rule.calls"
                            solo
                            @keydown="isNumber($event)"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 pa-1 SELECTSTATUSES>
                          <v-autocomplete
                            label="Call Status"
                            solo
                            v-model="rule.call_statuses"
                            hide-details
                            multiple
                            item-value="enumeration"
                            item-text="enumeration"
                            :items="sys"
                          >
                            <template
                                slot="selection"
                                slot-scope="{ item }"
                            >
                              <v-chip small style="font-size:9px;" label>{{item.enumeration}}</v-chip>
                            </template>

                            <template
                                slot="item"
                                slot-scope="{ parent, item }"
                            >
                              <v-list-tile-action>
                                <v-tooltip top>
                                  <template slot="activator">
                                    <v-icon on="on" color="error" v-if="item.description">info</v-icon>
                                  </template>
                                  <div>{{item.description}}</div>
                                </v-tooltip>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="item.enumeration"></v-list-tile-title>
                                <v-list-tile-sub-title v-if="item.cause" style="font-size:9px;"> cause: {{item.cause}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-if="item.description" style="font-size:9px;">{{item.description}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs2 pa-1>
                          <v-checkbox label="Switch to New Rules" v-model="rule.new" :value="true"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-btn color="primary" @click="jobsGroup.rules.push({})">add rule</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t1">
              <v-spacer></v-spacer>
              <v-btn color="success" :disabled="!companycode" :loading="loading" @click="saveSetting()">Update Settings</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 px-2 mb-2 JOB-LOG>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							AUTOMATION MONITOR
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t4 = !t4">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t4">
              <v-layout row wrap class="text-xs-left" align-base>
                <v-flex xs12 px-1 py-2 style="font-weight:bold;">
                  <v-progress-linear :value="logsProgress"></v-progress-linear>
                </v-flex>
                <v-flex xs6 px-1 py-2 style="font-weight:bold;">
                  MINUTE AUTOMATION LOG
                </v-flex>
                <v-flex xs6 px-1 py-2 style="font-weight:bold;">
                  CONTROL AUTOMATION LOG
                </v-flex>
                <v-flex xs6 px-1>
                  <v-layout row wrap class="text-xs-left" align-base>
                    <v-flex xs12 px-2 v-for="(log, am) in amlog" :key="am+'-amlog'" style="font-size:11px;">
                      {{log}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 px-1>
                  <v-layout row wrap class="text-xs-left" align-base>
                    <v-flex xs12 px-2 v-for="(log, am) in controllog" :key="am+'-controllog'" style="font-size:11px;">
                      {{log}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 px-1 py-2 style="font-weight:bold;">
                  MINUTE AUTOMATION RESULT
                </v-flex>
                <v-flex xs6 px-1 py-2 style="font-weight:bold;">
                  CONTORL AUTOMATION RESULT
                </v-flex>
                <v-flex xs6 px-1>
                  <v-layout row wrap class="text-xs-left" align-center>
                    <v-flex xs12 px-2 py-1 v-for="(result, r) in amresult" :key="r+'-amresult'" style="font-size:11px;">
                      <v-divider></v-divider>
                      <div style="font-weight:bold;">JOB {{result.id}}</div>
                      <div>NUMBERS RESET:</div>
                      <div>{{result.n.join(' | ')}}</div>
                      <div v-if="false">
                        <v-layout row wrap>
                          <v-flex xs6 v-for="(num, nn) in result.n" :key="'rnumb'+nn">
                            <v-btn @click="manualRemove(result.id, num)" small color="warning">{{num}}</v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div>JOB PAUSE: {{result.pauseJob.status_message}}</div>
                      <div>JOB RESET: {{result.reset.status_message}}</div>
                      <div>JOB ACTTIVE: {{result.activateJob.status_message}}</div>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 px-1>
                  <v-layout row wrap class="text-xs-left" align-center>
                    <div style="font-weight:bold;"> STATUS </div>
                    <v-flex xs12 px-2 py-1 v-for="(result, r) in controlresult.filter(x=>x.s)" :key="r+'-controlresult'" style="font-size:11px;">
                      <v-divider></v-divider>
                      <div style="font-weight:bold;">JOB {{result.id}}</div>
                      <div >JOB {{result.cc}}</div>
                      <div >JOB {{result.status}}</div>
                      <div >JOB {{result.active}}</div>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="text-xs-left" align-center>
                    <div style="font-weight:bold;">ACTIONS</div>
                    <v-flex xs12 px-2 py-1 v-for="(result, r) in controlresult.filter(x=>x.actions)" :key="r+'-controlresult'" style="font-size:11px;">
                      <v-divider></v-divider>
                      <div style="font-weight:bold;">JOB {{result.id}}</div>
                      <div>NUMBERS RESET:</div>
                      <div>{{result.action ? result.action : 'RESET AND ACTIVATE'}}</div>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t4">
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="loading" :disabled="!selectedJob" @click="saveSetting()">reset job</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Failed SKU Transaction</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  {{errors}}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="dialog = false">Dismiss</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import JsBarcode from 'jsbarcode'
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};
import https from 'https';

export default {
  data() {
    return {
      loading:false,
      dialog:false,
      t1:false,
      t2:false,
      t3:false,
      t4:false,
      t5:false,
      t6:false,
      t7:false,
      company_codes:[],
      jobsGroup:{jobs:[], rules:[]},
      errors:[],
      statuses:[],
      jobs:[],
      selectedJob:{},
      jobStatus:{},
      settings:[],
      callcenter:{fail:[], actions:[], inbound_campaigns:[]},
      companycode:null,
      customLog:null,
      result:null,
      sys:[],
      amlog:[],
      amresult:[],
      controllog:[],
      controlresult:[],
      logsProgress:0,
      countries:countriesJSON,
      misscalltimemenue:false,
    }
  },
  props:{
    userName:{},
    
  },
  methods:{
    async setStatuses(){
      this.sys = [{"enumeration":"SUCCESS"},{"enumeration":"UNSPECIFIED","cause":"Unspecified. No other cause codes applicable.","description":"This is usually given by the router when none of the other codes apply. This cause usually occurs in the same type of situations as cause 1, cause 88, and cause 100."},{"enumeration":"UNALLOCATED_NUMBER","cause":"Unallocated (unassigned) number [Q.850 value 1]","description":"This cause indicates that the called party cannot be reached because, although the called party number is in a valid format, it is not currently allocated (assigned)."},{"enumeration":"NO_ROUTE_TRANSIT_NET","cause":"No route to specified transit network (national use) [Q.850]","description":"This cause indicates that the equipment sending this cause has received a request to route the call through a particular transit network, which it does not recognize. The equipment sending this cause does not recognize the transit network either because the transit network does not exist or because that particular transit network, while it does exist, does not serve the equipment which is sending this cause."},{"enumeration":"NO_ROUTE_DESTINATION","cause":"No route to destination [Q.850]","description":"This cause indicates that the called party cannot be reached because the network through which the call has been routed does not serve the destination desired. This cause is supported on a network dependent basis."},{"enumeration":"CHANNEL_UNACCEPTABLE","cause":"channel unacceptable [Q.850]","description":"This cause indicates that the channel most recently identified is not acceptable to the sending entity for use in this call."},{"enumeration":"CALL_AWARDED_DELIVERED","cause":"call awarded, being delivered in an established channel [Q.850]","description":"This cause indicates that the user has been awarded the incoming call, and that the incoming call is being connected to a channel already established to that user for similar calls (e.g. packet-mode x.25 virtual calls)."},{"enumeration":"NORMAL_CLEARING","cause":"normal call clearing [Q.850]","description":"This cause indicates that the call is being cleared because one of the users involved in the call has requested that the call be cleared. Under normal situations, the source of this cause is not the network."},{"enumeration":"USER_BUSY","cause":"user busy [Q.850]","description":"This cause is used to indicate that the called party is unable to accept another call because the user busy condition has been encountered. This cause value may be generated by the called user or by the network. In the case of user determined user busy it is noted that the user equipment is compatible with the call."},{"enumeration":"NO_USER_RESPONSE","cause":"no user responding [Q.850]","description":"This cause is used when a called party does not respond to a call establishment message with either an alerting or connect indication within the prescribed period of time allocated."},{"enumeration":"NO_ANSWER","cause":"no answer from user (user alerted) [Q.850]","description":"This cause is used when the called party has been alerted but does not respond with a connect indication within a prescribed period of time. Note - This cause is not necessarily generated by Q.931 procedures but may be generated by internal network timers."},{"enumeration":"SUBSCRIBER_ABSENT","cause":"subscriber absent [Q.850]","description":"This cause value is used when a mobile station has logged off, radio contact is not obtained with a mobile station or if a personal telecommunication user is temporarily not addressable at any user-network interface. Sofia SIP will normally raise USER_NOT_REGISTERED in such situations."},{"enumeration":"CALL_REJECTED","cause":"call rejected [Q.850]","description":"This cause indicates that the equipment sending this cause does not wish to accept this call, although it could have accepted the call because the equipment sending this cause is neither busy nor incompatible. The network may also generate this cause, indicating that the call was cleared due to a supplementary service constraint. The diagnostic field may contain additional information about the supplementary service and reason for rejection."},{"enumeration":"NUMBER_CHANGED","cause":"number changed [Q.850]","description":"This cause is returned to a calling party when the called party number indicated by the calling party is no longer assigned, The new called party number may optionally be included in the diagnostic field. If a network does not support this cause, cause no: 1, unallocated (unassigned) number shall be used."},{"enumeration":"REDIRECTION_TO_NEW_DESTINATION","cause":"","description":"This cause is used by a general ISUP protocol mechanism that can be invoked by an exchange that decides that the call should be set-up to a different called number. Such an exchange can invoke a redirection mechanism, by use of this cause value, to request a preceding exchange involved in the call to route the call to the new number."},{"enumeration":"EXCHANGE_ROUTING_ERROR","cause":"","description":"This cause indicates that the destination indicated by the user cannot be reached, because an intermediate exchange has released the call due to reaching a limit in executing the hop counter procedure. This cause is generated by an intermediate node, which when decrementing the hop counter value, gives the result 0."},{"enumeration":"DESTINATION_OUT_OF_ORDER","cause":"destination out of order [Q.850]","description":"This cause indicates that the destination indicated by the user cannot be reached because the interface to the destination is not functioning correctly. The term \"not functioning correctly\" indicates that a signal message was unable to be delivered to the remote party; e.g. a physical layer or data link layer failure at the remote party, or user equipment off-line."},{"enumeration":"INVALID_NUMBER_FORMAT","cause":"invalid number format (address incomplete) [Q.850]","description":"This cause indicates that the called party cannot be reached because the called party number is not in a valid format or is not complete."},{"enumeration":"FACILITY_REJECTED","cause":"facilities rejected [Q.850]","description":"This cause is returned when a supplementary service requested by the user cannot be provide by the network."},{"enumeration":"RESPONSE_TO_STATUS_ENQUIRY","cause":"response to STATUS INQUIRY [Q.850]","description":"This cause is included in the STATUS message when the reason for generating the STATUS message was the prior receipt of a STATUS INQUIRY."},{"enumeration":"NORMAL_UNSPECIFIED","cause":"normal, unspecified [Q.850]","description":"This cause is used to report a normal event only when no other cause in the normal class applies."},{"enumeration":"NORMAL_CIRCUIT_CONGESTION","cause":"no circuit/channel available [Q.850]","description":"This cause indicates that there is no appropriate circuit/channel presently available to handle the call."},{"enumeration":"NETWORK_OUT_OF_ORDER","cause":"network out of order [Q.850]","description":"This cause indicates that the network is not functioning correctly and that the condition is likely to last a relatively long period of time e.g. immediately re-attempting the call is not likely to be successful."},{"enumeration":"NORMAL_TEMPORARY_FAILURE","cause":"temporary failure [Q.850]","description":"This cause indicates that the network is not functioning correctly and that the condition is not likely to last a long period of time; e.g. the user may wish to try another call attempt almost immediately."},{"enumeration":"SWITCH_CONGESTION","cause":"switching equipment congestion [Q.850]","description":"This cause indicates that the switching equipment generating this cause is experiencing a period of high traffic."},{"enumeration":"ACCESS_INFO_DISCARDED","cause":"access information discarded [Q.850]","description":"This cause indicates that the network could not deliver access information to the remote user as requested, i.e. user-to-user information, low layer compatibility, high layer compatibility or sub-address as indicated in the diagnostic. It is noted that the particular type of access information discarded is optionally included in the diagnostic."},{"enumeration":"REQUESTED_CHAN_UNAVAIL","cause":"requested circuit/channel not available [Q.850]","description":"This cause is returned when the other side of the interface cannot provide the circuit or channel indicated by the requesting entity."},{"enumeration":"PRE_EMPTED","cause":"","description":""},{"enumeration":"FACILITY_NOT_SUBSCRIBED","cause":"requested facility not subscribed [Q.850","description":"This cause indicates that the user has requested a supplementary service, which is available, but the user is not authorized to use."},{"enumeration":"OUTGOING_CALL_BARRED","cause":"outgoing calls barred","description":"This cause indicates that although the calling party is a member of the CUG for the outgoing CUG call, outgoing calls are not allowed for this member of the CUG."},{"enumeration":"INCOMING_CALL_BARRED","cause":"incoming calls barred","description":"This cause indicates that although the called party is a member of the CUG for the incoming CUG call, incoming calls are not allowed to this member of the CUG."},{"enumeration":"BEARERCAPABILITY_NOTAUTH","cause":"bearer capability not authorized [Q.850]","description":"This cause indicates that the user has requested a bearer capability that is implemented by the equipment which generated this cause but the user is not authorized to use."},{"enumeration":"BEARERCAPABILITY_NOTAVAIL","cause":"bearer capability not presently available [Q.850]","description":"This cause indicates that the user has requested a bearer capability which is implemented by the equipment which generated this cause but which is not available at this time."},{"enumeration":"SERVICE_UNAVAILABLE","cause":"service or option not available, unspecified [Q.850]","description":"This cause is used to report a service or option not available event only when no other cause in the service or option not available class applies."},{"enumeration":"BEARERCAPABILITY_NOTIMPL","cause":"bearer capability not implemented [Q.850]","description":"This cause indicates that the equipment sending this cause does not support the bearer capability requested."},{"enumeration":"CHAN_NOT_IMPLEMENTED","cause":"channel type not implemented [Q.850]","description":"This cause indicates that the equipment sending this cause does not support the channel type requested"},{"enumeration":"FACILITY_NOT_IMPLEMENTED","cause":"requested facility not implemented [Q.850]","description":"This cause indicates that the equipment sending this cause does not support the requested supplementary services."},{"enumeration":"SERVICE_NOT_IMPLEMENTED","cause":"service or option not implemented, unspecified [Q.850]","description":"This cause is used to report a service or option not implemented event only when no other cause in the service or option not implemented class applies."},{"enumeration":"INVALID_CALL_REFERENCE","cause":"invalid call reference value [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message with a call reference which is not currently in use on the user-network interface."},{"enumeration":"INCOMPATIBLE_DESTINATION","cause":"incompatible destination [Q.850]","description":"This cause indicates that the equipment sending this cause has received a request to establish a call which has low layer compatibility, high layer compatibility or other compatibility attributes (e.g. data rate) which cannot be accommodated."},{"enumeration":"INVALID_MSG_UNSPECIFIED","cause":"invalid message, unspecified [Q.850]","description":"This cause is used to report an invalid message event only when no other cause in the invalid message class applies."},{"enumeration":"MANDATORY_IE_MISSING","cause":"mandatory information element is missing [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message which is missing an information element which must be present in the message before that message can be processed."},{"enumeration":"MESSAGE_TYPE_NONEXIST","cause":"message type non-existent or not implemented [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message with a message type it does not recognize either because this is a message not defined of defined but not implemented by the equipment sending this cause."},{"enumeration":"WRONG_MESSAGE","cause":"message not compatible with call state or message type non-existent or not implemented. [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message such that the procedures do not indicate that this is a permissible message to receive while in the call state, or a STATUS message was received indicating an incompatible call state."},{"enumeration":"IE_NONEXIST","cause":"Information element / parameter non-existent or not implemented [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message which includes information element(s)/parameter(s) not recognized because the information element(s)/parameter name(s) are not defined or are defined but not implemented by the equipment sending the cause. This cause indicates that the information element(s)/parameter(s) were discarded. However, the information element is not required to be present in the message in order for the equipment sending the cause to process the message."},{"enumeration":"INVALID_IE_CONTENTS","cause":"Invalid information element contents [Q.850]","description":"This cause indicates that the equipment sending this cause has received and information element which it has implemented; however, one or more fields in the I.E. are coded in such a way which has not been implemented by the equipment sending this cause."},{"enumeration":"WRONG_CALL_STATE","cause":"message not compatible with call state [Q.850]","description":"This cause indicates that a message has been received which is incompatible with the call state."},{"enumeration":"RECOVERY_ON_TIMER_EXPIRE","cause":"recovery on timer expiry [Q.850]","description":"This cause indicates that a procedure has been initiated by the expiration of a timer in association with error handling procedures. This is often associated with NAT problems. Ensure that \"NAT Mapping Enable\" is turned on in your ATA. If it is not NAT related it can sometimes be provider related, make sure to ensure another outbound provider does not solve the problem.FreeSWITCH also returns this when the remote party sends a 408 for call expired."},{"enumeration":"MANDATORY_IE_LENGTH_ERROR","cause":"parameter non-existent or not implemented - passed on (national use) [Q.850]","description":"This cause indicates that the equipment sending this cause has received a message which includes parameters not recognized because the parameters are not defined or are defined but not implemented by the equipment sending this cause. The cause indicates that the parameter(s) were ignored. In addition, if the equipment sending this cause is an intermediate point, then this cause indicates that the parameter(s) were passed unchanged."},{"enumeration":"PROTOCOL_ERROR","cause":"protocol error, unspecified [Q.850]","description":"This cause is used to report a protocol error event only when no other cause in the protocol error class applies."},{"enumeration":"INTERWORKING","cause":"Interworking, unspecified [Q.850]","description":"This cause indicates that an interworking call (usually a call to SW56 service) has ended."},{"enumeration":"ORIGINATOR_CANCEL","cause":"","description":""},{"enumeration":"CRASH","cause":"","description":""},{"enumeration":"SYSTEM_SHUTDOWN","cause":"","description":""},{"enumeration":"LOSE_RACE","cause":"","description":""},{"enumeration":"MANAGER_REQUEST","cause":"","description":"This cause is used when you send an api command to make it hangup. For example uuid_kill <uuid>"},{"enumeration":"BLIND_TRANSFER","cause":"","description":""},{"enumeration":"ATTENDED_TRANSFER","cause":"","description":""},{"enumeration":"ALLOTTED_TIMEOUT","cause":"","description":"This cause means that the server canceled the call because the destination channel took too long to answer."},{"enumeration":"USER_CHALLENGE","cause":"","description":""},{"enumeration":"MEDIA_TIMEOUT","cause":"","description":""},{"enumeration":"PICKED_OFF","cause":"","description":"This cause means the call was picked up by intercepting it from another extension (i.e. dialing **ext_number from another extension)."},{"enumeration":"USER_NOT_REGISTERED","cause":"","description":"This means you tried to originate a call to a SIP user who forgot to register."},{"enumeration":"PROGRESS_TIMEOUT","cause":"","description":"See: progress_timeout"},{"enumeration":"GATEWAY_DOWN","cause":"","description":"Gateway is down (not answering on OPTIONS or SUBSCRIBE)"}]
    },
    goTo(path) {
      this.$router.push(path)
    },
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async loadCompanyCodes(){
      this.loading = true
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.company_codes = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
        console.log(this.company_codes)
      }
      this.loading = false
    },
    async loadStatuses(){
      this.loading = true
      let a = await db.ref('orderstatuses').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.statuses = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
        console.log(this.statuses)
      }
      this.loading = false
    },
    async loadSettings(){
      this.loading = true
      let a = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      if(a){
        this.settings = a
        console.log(a)
      }
      this.loading = false
    },
    async checkIfSettingExists() {
      console.log(this.jobsGroup)
      console.log(this.settings)
      console.log(this.settings.filter(x=>x.companycode == this.companycode).length)
      if(this.settings.filter(x=>x.companycode == this.companycode).length) {
        this.jobsGroup = this.settings.filter(x=>x.companycode == this.companycode)[0]
      } else {
        this.jobsGroup = {jobs:[], rules:[]}
      }
    },
    async loadJobs(){
      this.loading = true
      let a = await axios.get('https://apis.maen.me/ashcall/alljobs/').then(x=>x.data.data)

      if(a){
        this.jobs = a
        console.log(this.jobs)
      }
      this.loading = false
    },
    async checkJobStatus(){
      this.loading = true
      let a = await axios.get(`https://apis.maen.me/ashcall/jobstatus/?id=${this.selectedJob.job_id}`).then(x=>x.data.data)
      if(a){
        this.jobStatus = a
        console.log(a)
      }
      this.loading = false
    },
    async getJobNumbers(){
      this.loading = true
      let a = await axios.get(`https://apis.maen.me/ashcall/jobnumbers/?id=${this.selectedJob.job_id}`).then(x=>x.data.data)
      if(a){
        console.log(a)
      }
      this.loading = false
    },
    async startStopJob(active){
      this.loading = true
      let a = await axios.get(`https://apis.maen.me/ashcall/changejobstatus/?id=${this.selectedJob.job_id}&action=${active? 'RESUME' : 'PAUSE'}`).then(x=>x.data.data)
      if(a){
        console.log(a)
        this.checkJobStatus()
      }
      this.loading = false
    },
    async saveSetting() {
      this.loading = true
      this.jobsGroup.companycode = this.companycode
      if(!this.jobsGroup.key) {
        await store.collection('callcenter').add(this.jobsGroup)
      } else {
        await store.collection('callcenter').doc(this.jobsGroup.key).update(this.jobsGroup)
      }
      this.jobsGroup = {jobs:[], rules:[]}
      this.companycode = null
      this.loadSettings()
      this.loading = false
    },
    async saveCallCenterSettings() {
      this.loading = true
      let countries = this.countries
      for (let i = 0; i < this.callcenter.inbound_campaigns.length; i++) {
        if(this.callcenter.inbound_campaigns[i].country) {
          let country = this.callcenter.inbound_campaigns[i].country
          let cc = countries.filter(y=>y.name == country)[0].alpha2Code
          let callingCode = countries.filter(y=>y.name == country)[0].callingCodes[0]
          this.callcenter.inbound_campaigns[i].cc = cc
          this.callcenter.inbound_campaigns[i].callingCode = callingCode
        }
      }
      await db.ref('settings/callcenter').update(this.callcenter)
      this.loadCallCenterSettings()
      this.loading = false
    },
    async loadCallCenterSettings() {
      this.loading = true
      let a = await db.ref('settings/callcenter').once('value').then(x=>x.val())
      if(a) {
        if(!a.fail) a.fail = []
        if(!a.actions) a.actions = []
        if(!a.inbound_campaigns) a.inbound_campaigns = []
        this.callcenter = a
      }
      this.loading = false
    },
    async jobsTesting2(){
      
      // get numbers in certain job JOB > ID
      let a  = await axios.get(`https://apis.maen.me/ashcall/jobnumbers/?id=1105`).then(x=>x.data.data)
      console.log('jobnumbers', a)
      

      
      // let b = await this.getJobNumberStatus('1105', ["962785219523", "21651721899", "93658754885", "21651729899"])
      // console.log('getJobNumberStatus', b)
      // let c = await this.addNumbersToJob('1105', [
      //   {
      //     "job_fname":"fname",
      //     "job_lname":"last",
      //     "job_max_try":"1",
      //     "job_address":"add",
      //     "job_email_id":"na@gmail.com",
      //     "number":93958799881,
      //     "key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"
      //   }
      // ])
      // console.log('addNumbersToJob', c)
      // let d = await this.deleteNumbersFromJob('1105', ["23654744885", "23654724885"])
      // console.log('deleteNumbersFromJob', d)
      let e = await this.resetJobNumbers('1105', ["21651733825", "21651723825"])
      console.log('resetJobNumbers', e)


    },
    /// Hudo API
    async getAllJobs() {
      return new Promise(async (res, rej)=>{
        // check job status by ID in a JOB > ID
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","status":"ACTIVE"});

        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/getJob',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        try {
          let r = await axios(config)
          .then(x=>x)
          .catch(function (error) {
            console.log(error);
          });
          res(r ? r.data : r)
        } catch (error) {
          console.log(error)
        }
      })
    },
    async getJobStatus(id) {
      return new Promise(async (res, rej)=>{
        // check job status by ID in a JOB > ID
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/getJobStatus',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };

        try {
          let r = await axios(config)
          .then(x=>x)
          .catch(function (error) {
            console.log(error);
          });
          res(r ? r.data : r)
        } catch (error) {
          console.log(error)
        }
      })
    },
    async setJobStatus(id, action) {
      return new Promise(async (res, rej)=>{
        // check job status by ID in a JOB > ID
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"action":action});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/changeJobStatus',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };
        try {
          let r = await axios(config)
          .then(x=>x)
          .catch(function (error) {
            console.log(error);
          });
          res(r.data)
        } catch (error) {
          console.log(error)
        }
        
      })
    },
    async getJobNumbers(id) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        console.log('get', id)
        // var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id});
        let a = await axios.post(apiBase +'/getJobNumber', {id}, {headers}).then(x=>x.data)
        res(a.result)
      })
    },
    async getJobNumberStatus(id, numbers) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/getJobNumberStatus',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };

        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
        });
        res(r.data)
      })
    },
    async getJobNumberStatusBack(id, numbers) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        var data = {"token":"WFtT8nBwJOKB6ecq4Ulb","id":id,"numbers":numbers};
        let a = await axios.post(apiBase +'/getJobNumberStatusBack', data, {headers}).then(x=>x.data)
        res(a.result)
      })
    },
    async resetJobNumbers(id, numbers) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","reset_type":"RESETNUMBER","job_id":id,"numbers":numbers});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/resetJob',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };

        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
        });
        res(r.data)
      })
    },
    async addNumbersToJob(id, numbers) {
      return new Promise(async (res, rej)=>{
        // add numbers to job JOB > ID + NUMBERS (Formated)
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});
        console.log(data)
        // [{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658759882,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"},{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658799881,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"}]
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/addJobNumber',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            return error.response
          }
        });
        res(r.data)
      })
    },
    async updateNumbersInJob(id, numbers) {
      return new Promise(async (res, rej)=>{
        // add numbers to job JOB > ID + NUMBERS (Formated)
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});
        console.log(data)
        // [{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658759882,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"},{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658799881,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"}]
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/updateJobNumber',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            return error.response
          }
        });
        res(r.data)
      })
    },
    async deleteNumbersFromJob(id, numbers) {
      return new Promise(async (res, rej)=>{
        // add numbers to job JOB > ID + NUMBERS (Formated)
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});

        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/deleteJobNumber',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            return error.response
          }
        });
        res(r.data)
      })
    },
    async getCallHistory(phone_number){
      return new Promise(async (res, rej)=>{
        let a = await axios.get(apiBase +'/getCallHistory').then(x=>x.data)
        res(Object.values(a.result.result))
      })
    },
    // Automation
    async manualRemove(id, number){

    },
    async AutomationMinuteShortCycle(){
      return new Promise(async(res, rej)=>{
        this.loading = true
        this.result = '....'
        this.customLog = `GETTING JOBS`
        let jobs = await axios.get('https://apis.maen.me/ashcall/alljobs/').then(x=>x.data.data)
        this.customLog = `GOT ${jobs.length} JOBS`
        this.customLog = `GETTING CALL HISTORY`
        let call_history_ = await this.getCallHistory()
        let call_history = call_history_.map(x=>{
          return {
            phone_number:x.phone_number,
            call_start_time:x.call_start_time,
            timestamp:new Date(x.call_start_time).getTime(),
            hangup_reason:x.hangup_reason,
            call_status:x.call_status
          }
        })
        this.customLog = `GOT ${call_history.length} CALLS TODAY`
        console.log('jobs', jobs)
        console.log('call_history', call_history)
        let jobsIds = []
        for (let i = 0; i < jobs.length; i++) {
          const job = jobs[i];
          let jobstatus = await this.getJobStatus(job.job_id)
          this.customLog = `GOT JOB ID: ${job.job_id} STATUS`
          if(jobstatus && jobstatus.data && jobstatus.data.job_status != 'PAUSED'){
            jobsIds.push(jobstatus.data)
          }
        }
        let ccSettings = await db.ref('settings/callcenter').once('value').then(x=>x.val())
        let fail = await db.ref('settings/callcenter/fail').once('value').then(x=>x.val())
        console.log(fail)
        let exclude = ccSettings.automation.short_automation.exclude
        const good = ccSettings.automation.short_automation.good
        console.log('jobsIds', jobsIds)
        this.customLog = `GOT ALL JOBS TO PROCCESS: ${jobsIds.join(' | ')}`

        let jobIds = jobsIds.map(x=>x.job_id).filter(x=>!exclude.includes(x))
        let nstatuses = {}
        console.log('jobIds', jobIds);
        (async x=>{
          for (let i = 0; i < jobIds.length; i++) {
            const id = jobIds[i];
            this.customLog = `JOB ${id} Getting Numbers Statuses Start`
            if(true) {
              let jobnumbers = await this.getJobNumbers(id)
              console.log('jobnumbers', jobnumbers)
              const CYCLE_SIZE = parseInt(this.callcenter.cycle_size)
              let cycles = parseInt(jobnumbers.data.length / CYCLE_SIZE) + (jobnumbers.data.length % CYCLE_SIZE > 0 ? 1 : 0)
              console.log('cycles', cycles)

              let jobnstatuses = []
              for (let c = 0; c < cycles; c++) {
                console.log('cycles', c + 1 )
                this.customLog = `JOB ${id} Getting Numbers Statuses Cycle ${c+1}`
                let numberArray = jobnumbers.data.map(x=>x.number)
                console.log('numberArray', numberArray)
                console.log('numberArraySlice', numberArray.slice(c * CYCLE_SIZE, CYCLE_SIZE * (c+1)))
                let jobnumbersstatuses = await this.getJobNumberStatusBack(id, numberArray.slice(c*CYCLE_SIZE, CYCLE_SIZE * (c+1)))
                console.log('jobnumbersstatuses', jobnumbersstatuses.data);
                jobnstatuses.push(
                  ...Object.values(jobnumbersstatuses.data)
                  .map(x=>{
                    return { 
                      ...x, 
                      JobId:id, 
                      calls:call_history
                      .filter(y=>y.phone_number == x.PhoneNumber)
                      .filter(y=> y.call_status != 'ABANDONED')
                      .sort((a, b) => a.timestamp - b.timestamp)
                  }})
                  .filter(x=>!jobnstatuses.map(y=>y.PhoneNumber).includes(x.PhoneNumber)) // Filter Existing
                  .filter(x=>x.TryDone != '0') // Filter Existing
                  .filter(x=>x.HangupReason && !good.includes(x.HangupReason)) // Filter Good Statuses
                  .filter(x=> x.calls.length <= fail.filter(y=>y.status == x.HangupReason).length &&  fail.filter(y=>y.status == x.HangupReason)[0] && fail.filter(y=>y.status == x.HangupReason)[0].retries ? parseInt(fail.filter(y=>y.status == x.HangupReason)[0].retries) : 9999999 ) //////////////////
                );
              }
              console.log('jobnstatuses', jobnstatuses)
              this.customLog = `JOB ${id} has ${jobnstatuses.length} to RESET`

              console.log('HangupReasons', jobnstatuses.map(x=>x.HangupReason))
              console.log('HangupReasons', jobnstatuses.map(x=>x.Disposition))
              if(jobnstatuses.length) {
                if(!nstatuses[id]) nstatuses[id] = []
                nstatuses[id].push(...jobnstatuses.filter(x=>!nstatuses[id].map(y=>y.PhoneNumber).includes(x.PhoneNumber)))
              } 
            }
          }
          console.log('nstatuses', nstatuses);

          let jIDs = Object.keys(nstatuses)
          let nums = Object.values(nstatuses)
          this.customLog = `JOBS to Reset ${jIDs.join(' | ')} Total Numbers ${ nums.length }`
          this.result = ``
          for (let i = 0; i < jIDs.length; i++) {
            const id = jIDs[i];
            const n = nums[i].map(x=>x.PhoneNumber);
            this.customLog = `JOB ${id} pausing`
            let pauseJob = await this.setJobStatus(id, 'PAUSE');
            console.log('pauseJob', pauseJob)
            this.customLog = `JOB ${id} resetting all number`
            let reset = await this.resetJobNumbers(id, n)
            this.customLog = `JOB ${id} RESET result ${reset.status_message}`
            this.result += `${this.customLog}\n`
            console.log('reset', reset)
            this.customLog = `JOB ${id} activating`
            let activateJob = await this.setJobStatus(id, 'RESUME');
            console.log('activateJob', activateJob)
            this.result += `JOB ${id} RESUME result ${activateJob.status_message}\n`
          }
          this.loading = false
          res(true)
        })()
      })
    },
    async controlAutomation(){
      return new Promise(async(res, rej)=>{
        this.loading = true
        this.result = '....'
        this.customLog = `LOADING CALL HISTORY`
        let call_history_ = await this.getCallHistory()
        let call_history = call_history_.map(x=>{
          return {
            phone_number:x.phone_number,
            call_start_time:x.call_start_time,
            timestamp:new Date(x.call_start_time).getTime(),
            hangup_reason:x.hangup_reason,
            call_status:x.call_status
          }
        })
        this.customLog = `GOT ${call_history.length} CALLS TODAY`
        let settings = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
          return {
            ...y.data(), 
            key:y.id,
          }
        }))
        let ccSettings = await db.ref('settings/callcenter').once('value').then(x=>x.val())
        let fail = await db.ref('settings/callcenter/fail').once('value').then(x=>x.val())
        let exclude = ccSettings.automation.short_automation.exclude
        console.log('ccSettings', ccSettings)
        let agents = parseInt(ccSettings.agents)
        let calls = parseInt(ccSettings.calls)
        this.customLog = `LOADED SETTINGS > ${agents} Agents will get ${calls} Calls`
        const good = ccSettings.automation.short_automation.good
        console.log('settings', settings)
        let jobIds = [].concat(
          ...settings
          .sort((a, b)=> parseInt(a.priority) - parseInt(b.priority))
          .map(x=>x.jobs.filter(x=>!x.lock).filter(x=>!exclude.includes(x.job.job_id))
            .map(job=>{
              return {
                ...job, 
                id:job.job.job_id, 
                priority:parseInt(job.priority), 
                con:parseInt(job.con), 
                cccon:parseInt(x.con), 
                ccpriority:parseInt(x.priority),
                cckey:x.key
              }
            })
          )
        );
        let cc_con = settings.map(x=>{return {con:x.con, key:x.key}})
        let nstatuses = {}
        this.customLog = `JOB IDs to proccess > COUNT: ${jobIds.length}`
        console.log('jobIds', jobIds);
        (async x=>{
          for (let i = 0; i < jobIds.length; i++) {
            const id = jobIds[i].id;
            this.customLog = `JOB ID ${id}`
            const ccpriority = jobIds[i].ccpriority;
            const key = jobIds[i].cckey;
            let cccon = cc_con.filter(x=>x.key == key)[0].con
            const priority = jobIds[i].priority;
            const jobNew = jobIds[i].new;
            const jobLock = jobIds[i].lock;
            const con = jobIds[i].con;
            console.log('ccpriority', ccpriority)
            console.log('priority', priority)
            let jobstatus = await this.getJobStatus(id)
            console.log('jobstatus', jobstatus)
            let cStatus = ["SCHEDULED", "PAUSE"]
            if(jobstatus && jobstatus.data &&(cStatus.includes(jobstatus.data.job_status) || true || jobNew) && !jobLock && con <= cccon && con <= calls) {
              this.customLog = `JOB ID ${id} | Geting Numbers`
              let jobnumbers = await this.getJobNumbers(id)
              console.log('jobnumbers', jobnumbers)
              const CYCLE_SIZE = parseInt(this.callcenter.cycle_size)
              let cycles = parseInt(jobnumbers.data.length / CYCLE_SIZE) + (jobnumbers.data.length % CYCLE_SIZE > 0 ? 1 : 0)
              console.log('cycles', cycles)
              let jobnstatuses = []
              for (let c = 0; c < cycles; c++) {
                console.log('cycles', c + 1 )
                let numberArray = jobnumbers.data.map(x=>x.number)
                console.log('numberArray', numberArray)
                console.log('numberArraySlice', numberArray.slice(c * CYCLE_SIZE, CYCLE_SIZE * (c+1)))
                this.customLog = `JOB ID ${id} | Geting Numbers Statuses of ${numberArray.length} Numbers`
                let jobnumbersstatuses = await this.getJobNumberStatusBack(id, numberArray.slice(c*CYCLE_SIZE, CYCLE_SIZE * (c+1)))
                console.log('jobnumbersstatuses', jobnumbersstatuses.data);
                jobnstatuses.push(
                  ...Object.values(jobnumbersstatuses.data)
                  .map(x=>{
                    return { 
                      ...x, 
                      JobId:id, 
                      calls:call_history
                      .filter(y=>y.phone_number == x.PhoneNumber)
                      .filter(y=> y.call_status != 'ABANDONED')
                      .sort((a, b) => a.timestamp - b.timestamp)
                  }})
                  .filter(x=>!jobnstatuses.map(y=>y.PhoneNumber).includes(x.PhoneNumber)) // Filter Existing
                  .filter(x=>x.TryDone != '0') // Filter Existing
                  .filter(x=>x.HangupReason && !good.includes(x.HangupReason)) // Filter Good Statuses
                  .filter(x=> x.calls.length <= fail.filter(y=>y.status == x.HangupReason).length ? parseInt(fail.filter(y=>y.status == x.HangupReason)[0].retries) : 9999999 ) //////////////////
                );
                this.customLog = `JOB ID ${id} | ${jobnstatuses.length} valid to reset`
              }
              console.log('jobnstatuses', jobnstatuses)
              console.log('con', con)
              console.log('calls', calls)
              if(jobnstatuses.length) {
                if(!nstatuses[id]) nstatuses[id] = []
                nstatuses[id].push(...jobnstatuses.filter(x=>!nstatuses[id].map(y=>y.PhoneNumber).includes(x.PhoneNumber)))
                calls -= con
                cc_con.filter(x=>x.key == key)[0].con -= con
              } else {
                try {
                  this.customLog = `JOB ID ${id} | PAUSING`
                  // let pauseJob = await this.setJobStatus(id, 'PAUSE');
                  // console.log('pauseJob', pauseJob)
                } catch (error) {
                  console.log(error)
                }
              }
            }
          }
          console.log('remaining', calls);
          

          console.log('nstatuses', nstatuses);
          let jIDs = Object.keys(nstatuses)
          let nums = Object.values(nstatuses)
          for (let i = 0; i < jIDs.length; i++) {
            const id = jIDs[i];
            this.customLog = `JOB ID ${id} | PAUSE > RESET > RESUME`
            const n = nums[i].map(x=>x.PhoneNumber);
            this.customLog = `JOB ${id} pausing`
            // let pauseJob = await this.setJobStatus(id, 'PAUSE');
            // console.log('pauseJob', pauseJob)
            this.customLog = `JOB ${id} resetting all number`
            // let reset = await this.resetJobNumbers(id, n)
            // this.customLog = `JOB ${id} RESET result ${reset.status_message}`
            // this.result = `${this.customLog}\n`
            // console.log('reset', reset)
            // this.customLog = `JOB ${id} activating`
            // let activateJob = await this.setJobStatus(id, 'RESUME');
            this.customLog = `JOB ${id} activate`
            // this.result = `JOB ${id} RESUME result ${activateJob.status_message}\n`
            // console.log('activateJob', activateJob)
          }
          this.result = `.\n.\n.\n.\n.\n`
          this.result = `Remaining ${calls}\n`
          this.loading = false
          res(true)
        })()
      })
    },
    async AutomationDayCycle(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.result = '....'
        this.customLog = `LOADING FAILED`
        let fail = await db.ref('settings/callcenter/fail').once('value').then(x=>x.val())
        this.customLog = `LOADING SETTINGS`
        let settings = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
          return {
            ...y.data(), 
            key:y.id,
          }
        }));
        this.customLog = `LOADING CALL HISTORY`
        let call_history_ = await this.getCallHistory()
        let call_history = call_history_.map(x=>{
          return {
            phone_number:x.phone_number,
            call_start_time:x.call_start_time,
            timestamp:new Date(x.call_start_time).getTime(),
            hangup_reason:x.hangup_reason,
            call_status:x.call_status
          }
        })
        this.customLog = `GOT ${call_history.length} CALLS TODAY`
        console.log('settings', settings);
        console.log('call_history', call_history);
        let rules_ = [];
        for (let i = 0; i < settings.length; i++) {
          const cc_setting = settings[i];
          let jobs = cc_setting.jobs
          for (let k = 0; k < cc_setting.rules.length; k++) {
            const rule = cc_setting.rules[k];
            const good = rule.call_statuses ? rule.call_statuses : []
            console.log('rule good', good)
            this.customLog = `RULE: ${rule.fstatus} -> ${rule.tstatus}`
            
            let ffilter = jobs.filter(x=>x.status == rule.fstatus)
            let tfilter = jobs.filter(x=>x.status == rule.tstatus) 
            let fjob = ffilter.length ? ffilter[0] : null
            let tjob = tfilter.length ? tfilter[0] : null
            if(fjob && tjob) {
              let jobnumbers = await this.getJobNumbers(fjob.job.job_id)
              console.log('jobnumbers', jobnumbers)
              if(jobnumbers.data && jobnumbers.data.length) {
                let numberstatuses = await this.getJobNumberStatusBack(fjob.job.job_id, jobnumbers.data.map(x=>x.number))
                console.log('rule good', good)
                this.customLog = `RULE: GOT NUMBERS + STATUSES`
                
                // console.log('jobns', jobnumbers, 'jobnss', numberstatuses)
                rule.numbers = jobnumbers.data.map(x=>{
                  return {...x, ...numberstatuses.data[x.number]}
                })
                .filter(x=>x.TryDone != '0') // Filter Existing
                .filter(x=>good.includes(x.HangupReason)) // Filter Good Statuses
                rules_.push({
                  ...rule,
                  fjob,
                  tjob,
                  ccpriority:cc_setting.priority,
                  cccon:cc_setting.con,
                })
              }
            }
          }
        }
        let deleteNumbers = {}
        let addNumbers = {}
        let changeOrders = []
        for (let i = 0; i < rules_.length; i++) {
          const rule = rules_[i];
          this.customLog = `RULE: ${rule.fstatus} -> ${rule.tstatus}`

          console.log('rule', rule)
          for (let k = 0; k < rule.numbers.length; k++) {
            const number = rule.numbers[k];
            let orders = number.CustomerName.replace(/-/g, '|').split('|').filter(x=>x && x!='').map(x=> `${x.replace(/!/g, '-')}`)
            this.customLog = `RULE: Sorting ${number.PhoneNumber}`
            console.log(number)
            console.log(orders)
            let ch = call_history
            .filter(x=>x.phone_number == number.PhoneNumber)
            .filter(x=> x.call_status != 'ABANDONED')
            .sort((a, b) => a.timestamp - b.timestamp)
            console.log('call history', ch)

            if(
                ch.length >= parseInt(rule.calls) 
                && (ch[ch.length-1].timestamp - ch[0].timestamp) >= (parseInt(rule.hours) * 60 * 60 * 1000)
            ) {
              // Success Neet To Move
              // Delete from job
              console.log('rule.fjob.job', rule.fjob.job, 'rule.fjob.job_id', rule.fjob.job.job_id)
              if(!deleteNumbers[rule.fjob.job.job_id]) deleteNumbers[rule.fjob.job.job_id] = {}
              if(!deleteNumbers[rule.fjob.job.job_id].job_id) deleteNumbers[rule.fjob.job.job_id].job_id = rule.fjob.job.job_id
              if(!deleteNumbers[rule.fjob.job.job_id].numbers) deleteNumbers[rule.fjob.job.job_id].numbers = []
              deleteNumbers[rule.fjob.job.job_id].numbers.push(number.PhoneNumber)
              
              // RULE NEW must Switch phone 1 if not == phone 2 and add to NEW 
              if(rule.new) {
                // Get Order
                let check = {sw:false, prime:null}
                for (let k = 0; k < orders.length; k++) {
                  const o = orders[k];
                  if(!check.sw) {
                    let o_object = await store.collection('leads').doc(o).get().then(x=>x.data())
                    // check phones
                    if( o_object.phone_number_1 && o_object.phone_number_2 
                      && o_object.switched
                      && o_object.phone_number_1 != o_object.phone_number_2 && o_object.phone_number_2.length > 4) {
                      let p1 = o_object.phone_number_1
                      let p2 = o_object.phone_number_2
                      number.PhoneNumber = p2
                      check.sw = true
                      check.prime = o
                      // switch on crm
                      await store.collection('leads').doc(o)
                      .update({phone_number_1:p1, phone_number_2:p2, switched:true, new_switch:false})
                    }
                  }
                }
                for (let k = 0; k < orders.filter(x=> x!= check.prime).length; k++) {
                  // switching rest
                  await store.collection('leads').doc(o)
                  .update({phone_number_1:p1, phone_number_2:p2, switched:true, new_switch:false})
                }
              } 
              // Add to tjob
              if(!rule.new || (rule.new && sw)){
                if(!addNumbers[rule.tjob.job.job_id]) addNumbers[rule.tjob.job.job_id] = {}
                if(!addNumbers[rule.tjob.job.job_id].job_id) addNumbers[rule.tjob.job.job_id].job_id = rule.tjob.job.job_id
                if(!addNumbers[rule.tjob.job.job_id].numbers) addNumbers[rule.tjob.job.job_id].numbers = []
                addNumbers[rule.tjob.job.job_id].numbers.push({
                  "job_fname": number.CustomerName.split('-')[0],
                  "job_lname":number.CustomerName.split('-')[1],
                  "job_max_try":"1",
                  "job_address":"add",
                  "job_email_id":"na@gmail.com",
                  "number":number.PhoneNumber,
                })
                // Change status on CRM to all -> orders > tstatus
                orders.forEach(key=>{
                  changeOrders.push({key, status:rule.tstatus})
                })
              }
            }
            // get call history
            // delete from fjob
            // add to tjob
            // update all order keys to new status
            // if switch to new (swn rules)
          }
        }
        console.log('deleteNumbers', deleteNumbers)
        let delete_array = Object.values(deleteNumbers)
        for (let i = 0; i < delete_array.length; i++) {
          const job = delete_array[i];
          this.customLog = `DELETEING NUMBERS FROM JOB ${job.job_id}`
          try {
            let r = await this.deleteNumbersFromJob(job.job_id, job.numbers)
            console.log(r)
          } catch (error) {
            
          }
          
        }
        console.log('addNumbers', addNumbers)
        let add_array = Object.values(addNumbers)
        for (let i = 0; i < add_array.length; i++) {
          const job = add_array[i];
          this.customLog = `ADDING NUMBERS TO JOB ${job.job_id}`
          try {
            let r = await this.addNumbersToJob(job.job_id, job.numbers)
            console.log(r)
          } catch (error) {
          }
        }
        console.log('changeOrders', changeOrders)
        for (let i = 0; i < changeOrders.length; i++) {
          const o = changeOrders[i];
          this.customLog = `Updating Order: ${o.key}`
          try {
            let l = await store.collection('leads').doc(o.key).get().then(x=>x.data())
            let bb = await db.ref('uKeys').push()
            if(!l.update_timeline) l.update_timeline = {}
            l.update_timeline[bb.key] = {
              status:o.status,
              agent:this.$props.userName,
              date:getCDate()
            }
            await db.ref('uKeys').update({
              [bb.key]:null
            })
            l.order_status = o.status
            let r = await store.collection('leads').doc(o.key).update(l)
            console.log(l)
          } catch (error) {
          }
        }
        console.log('rules_', rules_)

        this.loading = false
        res(true)
      })
    },
    async Automation(lead){
      return new Promise(async(res, rej)=>{
        let call_rules = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
          return {
            ...y.data(), 
            key:y.id,
          }
        }))
        lead.company_code = lead.company_code.toUpperCase()
        let filter = call_rules.filter(x=>x.companycode.toUpperCase() == lead.company_code)
        if(filter && filter.length) {
          let jobs = filter[0].jobs;
          console.log('jobs', jobs)
          if(lead.order_status == 'NEW') {
            let jo = jobs.filter(x=>x.status == 'NEW')
            if(jo && jo.length){
              let job = jo[0].job
              let id = job.job_id
              let check = await this.getJobNumberStatus(id, [lead.phone_number_1])
              let search_key = lead.key.replace(/-/g, '!')
              console.log('check', check, 'here')
              if( check 
                  && check.data 
                  && check.data[lead.phone_number_1] 
                  && check.data[lead.phone_number_1].message != 'Invalid Number or No Record Found.'
              ) {
                let on = check.data[lead.phone_number_1]
                let keys = on.CustomerName.replace(/-/g, '|').split('|').filter(x=>x && x!='')
                console.log('keys', keys)
                console.log('keys.length', keys.length)
                console.log('keys.includes(search_key)', search_key)
                console.log('keys.includes(search_key)', keys.includes(search_key))
                if(!keys.includes(search_key)) {
                  if(keys.length<2) {
                    let update = await this.updateNumbersInJob(id, [
                      {
                        "job_fname": keys[0] + '|' + search_key,
                        "job_lname":'',
                        "job_max_try":"1",
                        "job_address":"add",
                        "job_email_id":"na@gmail.com",
                        "number":lead.phone_number_1,
                        "key":lead.key
                      }
                    ])
                    console.log('update', update)
                  } else if(keys.length<3) {
                    let update = await this.updateNumbersInJob(id, [
                      {
                        "job_fname":  keys.slice(0, 2).join('|'),
                        "job_lname": search_key,
                        "job_max_try":"1",
                        "job_address":"add",
                        "job_email_id":"na@gmail.com",
                        "number":lead.phone_number_1,
                        "key":lead.key
                      }
                    ])
                    console.log('update', update)
                  } else {
                    let update = await this.updateNumbersInJob(id, [
                      {
                        "job_fname":  keys.slice(0, 2).join('|'),
                        "job_lname": keys.slice(2, 3).join('|') + '|' + search_key,
                        "job_max_try":"1",
                        "job_address":"add",
                        "job_email_id":"na@gmail.com",
                        "number":lead.phone_number_1,
                        "key":lead.key
                      }
                    ])
                    console.log('update', update)
                  }
                  
                }
              } else {
                let addToJob = await this.addNumbersToJob(id, [
                  {
                    "job_fname": search_key,
                    "job_lname":'',
                    "job_max_try":"1",
                    "job_address":"add",
                    "job_email_id":"na@gmail.com",
                    "number":lead.phone_number_1,
                    "key":lead.key
                  }
                ])
                console.log('addToJob', addToJob)
              }
            }
          }
        }
      })
    },
    async GetLeadJob(lead){
      return new Promise(async (res, rej)=>{
        if(!lead) {
          rej(false)
        }
        let actions = await db.ref('settings/callcenter/actions').once('value').then(x=>x.val())
        console.log('actions', actions)
        let status = lead.order_status
        console.log('status', status)
        let lead_action = actions.filter(x=>x.do != 'NOTHING').filter(x=> x.status == status) 
        if(lead_action.length || lead.new_switch) {
          let action = lead_action[0].do
          console.log('action', action)
          let call_rules = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
            return {
              ...y.data(), 
              key:y.id,
            }
          }))
          lead.company_code = lead.company_code.toUpperCase()
          let filter = call_rules.filter(x=>x.companycode.toUpperCase() == lead.company_code)
          if(filter && filter.length) {
            let jobs = filter[0].jobs;
            console.log('jobs', jobs)
            for (let i = 0; i < jobs.length; i++) {
              const job = jobs[i];
              console.log('job.job.job_id', job.job.job_id)
              let numbers_call = await this.getJobNumbers(job.job.job_id)
              let numbers = numbers_call.data
              .filter(x=> x.number == lead.phone_number_1)
              if(numbers.length){
                if(action == 'REMOVE') {
                  console.log('REMOVE')
                  let r = await this.deleteNumbersFromJob(job.job.job_id, [lead.phone_number_1])
                  console.log(r)
                } else if (action == 'RESET') {
                  console.log('RESET')
                  let st = await this.getJobStatus(job.job.job_id)
                  console.log(st)
                  if(st.data.job_status == 'RUNNING' || st.data.job_status == 'SCHEDULED') {
                    let pauseJob = await this.setJobStatus(job.job.job_id, 'PAUSE');
                    console.log(pauseJob)
                  }
                  let r = await this.resetJobNumbers(job.job.job_id, [lead.phone_number_1])
                  console.log(r)
                  if(st.data.job_status == 'RUNNING' || st.data.job_status == 'SCHEDULED') {
                    let activateJob = await this.setJobStatus(job.job.job_id, 'RESUME');
                    console.log(activateJob)
                  }
                }
              }
              if(lead.new_switch) {
                let numbers = numbers_call.data
                .filter(x=> x.number == lead.phone_number_2)
                if(numbers.length){
                  console.log('REMOVE PH2 (old PH1)')
                  // let r = await this.deleteNumbersFromJob(job.job.job_id, [lead.phone_number_2])
                  // console.log(r)
                }
              }
            }
            let newJob = filter[0].jobs.filter(x=>x.status = 'NEW')
            if(newJob.length && lead.new_switch) {
              console.log('ADD PH1 (old PH2)')
              // let r = await this.addNumbersToJob(job.job_id, [lead.phone_number_1])
              // console.log(r)
              console.log('Update Lead Not to Switch Again')
              // await store.collection('leads').doc(lead.key).update({new_switch:false, order_status:'NEW'})
            } else {
              res(true)
            }
            res(true)
          } else {
            res(true)
          }
        } else {
          res(true)
        }
      })
    },
    async jobsTesting(){
      let lead = {
        company_code:'Ashyaat Iraq',
        order_status:'NEW',
        key:`-${randomString(19, '#Aa')}-adW`,
        name: 'Maen Househ',
        // order_status: 'Confirmed',
        phone_number_1:'962785219523' // getRandomInt(10000000000, 99999999999)
      }
      console.log('start >', new Date().getTime())
      // await this.GetLeadJob(lead)
      // await this.controlAutomation()        
      await this.Automation(lead)
      console.log('end >', new Date().getTime())
    },
    async loadingLogs(){
      setInterval(x=>{
        this.logsProgress += (500 * 100 / 10000)
      }, 500)
    },
    async pullLogs(){
      setInterval(async x=>{
        if(this.t4) {
          const agent = new https.Agent({  
            rejectUnauthorized: false
          });
          let a = await axios.get(`https://callcenter.waashyaat.com/active-minute-log`, { httpsAgent: agent }).then(x=>x.data)
          let b = await axios.get(`https://callcenter.waashyaat.com/active-minute-result`, { httpsAgent: agent }).then(x=>x.data)
          console.log('active-minute-log', a)
          console.log('active-minute-result', b)
          this.amlog = a.log.map(x=>x.value)
          this.amresult = b.result
          let c = await axios.get(`https://callcenter.waashyaat.com/control_log`, { httpsAgent: agent }).then(x=>x.data)
          let d = await axios.get(`https://callcenter.waashyaat.com/control_result`, { httpsAgent: agent }).then(x=>x.data)
          console.log('control-log', c)
          console.log('control-result', d)
          this.controllog = c.log.map(x=>x.value)
          this.controlresult = d.result
        }
        this.logsProgress = 0
      }, 10000)
    }
  },
  watch:{
    
  },
  computed:{
    
  },
  async created(){
    this.setStatuses()
    this.loadCallCenterSettings()
    this.loadStatuses()
    this.loadCompanyCodes()
    this.loadJobs()
    this.loadSettings()
    this.loadingLogs()
    this.pullLogs()

  }
}
</script>

<style>

</style>
